<template>
  <v-progress-linear
    :value="value"
    @input="updateValue"
    :color="color ? color : 'primary'"
    v-bind="$attrs"
  >
    <strong style="color: #ffffff">{{ value }}%</strong>
  </v-progress-linear>
</template>

<script>
export default {
  name: "p-progress-bar",

  props: ["value", "color"],

  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
</script>
